import { render, staticRenderFns } from "./RawMatDetail.vue?vue&type=template&id=007b034e&scoped=true&"
import script from "./RawMatDetail.vue?vue&type=script&lang=js&"
export * from "./RawMatDetail.vue?vue&type=script&lang=js&"
import style0 from "./RawMatDetail.vue?vue&type=style&index=0&id=007b034e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b034e",
  null
  
)

export default component.exports